





























































































































































import { Component } from 'vue-property-decorator';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import VerDetalleModal from './VerDetalleModal.vue';
import WidgetAlerta from '@/pantallas/Camaras/Alertas/WidgetAlerta.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import showImage from '@/pantallas/Camaras/Alertas/showImage.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

@Component({
  components: {
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    VerDetalleModal,
    WidgetAlerta,
    showImage,
    FormFieldsContainer,
    DatePicker,
  },
})
export default class ReportesSerieBase extends ComponenteBase {
  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades = Funcionalidades.ReportesNoSeriados;

  loadingService = new LoadingService();
  filtrobusquedagrilla: string = '';
  mostrarModalVerDetalle: boolean = false;

  columnApi: any = null;
  gridEvent: any = null;
  serverSide: any;
  gridApi: GridApi = null;
  showReporteGenerado: boolean = false;
  texto_reporte: string = '';
  ordesList: any[] = [];
  equiposlist: any[] = [];
  requermientoslist: any[] = [];
  racklist: any[] = [];
  ubicacionlist: any[] = [];
  bloquelist: any[] = [];
  crm_rutlist: any = [];

  usuarioID: any = '';
  pagina: number = 1;
  cant_regs_pag: number = 25;

  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie({ '': '' }, 'reportesNoSerie/get_grilla_filters')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.equiposlist = data.data.EQUIPO;
          self.requermientoslist = data.data.REQUERIMIENTOS;
          self.ubicacionlist = data.data.UBICACION;
          self.racklist = data.data.RACK;
          self.bloquelist = data.data.BLOQUE;
          self.crm_rutlist = data.data.CRM_RUT;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'asignumero',
        field: 'Número de Preparación',
        lockVisible: true,
        hide: true,
      },
      {
        headerName: 'Nro. de Preparación',
        field: 'Número de Preparación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
      },
      {
        headerName: 'Fecha de Preparación',
        field: 'Fecha de Preparación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        valueFormatter: function(params) {
          return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
        },
      },
      {
        headerName: 'Requerimiento',
        field: 'Requerimiento',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Flota Praparación',
        field: 'Flota Preparación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'RUT Cliente',
        field: 'Rut Cliente',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Razón Social',
        field: 'Razón Social',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Modalidad',
        field: 'Modalidad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'No. Item',
        field: 'No Ítem',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Tipo de Equipo',
        field: 'Tipo de Equipo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Cantidad',
        field: 'Cantidad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
      },

      {
        headerName: 'Observación',
        field: 'Observación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
      },

      {
        headerName: 'Ubicación Actual',
        field: 'Ubicación Actual',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Fecha de Ingreso',
        field: 'Fecha de Ingreso',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        valueFormatter: function(params) {
          return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
        },
      },
      {
        headerName: 'Fecha de Egreso',
        field: 'Fecha de Egreso',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        valueFormatter: function(params) {
          return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
        },
      },
      {
        headerName: 'Tipo de Operación',
        field: 'Tipo de Operación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },

      {
        headerName: 'No. de operación',
        field: 'NumeroOperacion',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 100,
      },
      {
        headerName: 'Rack',
        field: 'Rack',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Bloque',
        field: 'Bloque',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Días de Estadía',
        field: 'Días de Estadía',
        cellStyle: { textAlign: 'center' },
        resizable: true,
        width: 140,
      },
    ],

    pagination: true,
    paginationPageSize: this.cant_regs_pag,
    cacheBlockSize: this.cant_regs_pag,
    paginationAutoPageSize: false,
    rowModelType: 'serverSide',
    serverSideDatasource: this.serverSide,
    onGridReady: this.handleGridReady,
    overlayNoRowsTemplate: 'No hay filas para mostrar',
  };

  formFields: FormFieldDefMap = {
    ubicacion: {
      label: 'Ubicación',
      id: '',
      value: '',
    },
    fechaingresoInicio: {
      label: 'Fecha de Ingreso Inicio',
      id: 'fechaingreso',
      value: moment()
        .subtract(1, 'month')
        .startOf('day')
        .hour(1),
    },
    fechaingresoFin: {
      label: 'Fecha de Ingreso Fin',
      id: 'fechaingreso',
      value: moment()
        .startOf('day')
        .hour(12),
    },
    rut: {
      label: 'Rut Cliente',
      id: '',
      value: '',
    },
    requerimiento: {
      label: 'Requerimiento',
      id: '',
      value: '',
    },
    TipoEquipo: {
      label: 'Tipo de Equipo',
      id: '',
      value: '',
    },

    rack: {
      label: 'Rack',
      id: '',
      value: '',
    },
    Bloque: {
      label: 'Bloque',
      id: '',
      value: '',
    },
  };
  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }
  handleBuscarClick() {
    this.filtroRequerimiento(true);
  }
  get fechaMaximaInicio() {
    //let fechaMax = this.formFields.fechaInicio.value;

    return moment(this.fechaMaxima) as moment.Moment;
    //return fechaMax as moment.Moment;
  }

  async clearFilters() {
    this.formFields.ubicacion.value = undefined;
    this.formFields.fechaingreso.value = undefined;
    this.formFields.rut.value = undefined;
    this.formFields.requerimiento.value = undefined;
    this.formFields.TipoEquipo.value = undefined;
    this.formFields.rack.value = undefined;
    this.formFields.Bloque.value = undefined;
  }
  async handleGridReady(event: GridReadyEvent) {
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    this.gridApi = event.api;
    this.gridApi.setDomLayout('autoHeight');
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    let self = this;
    this.serverSide = {
      getRows(event: any): void {
        let body: any = self.filtros2body();
        if (body.ubicacion == '') {
          self.$snotify.error('El campo ubicación en requerido', {
            timeout: 3000,
          });
          event.successCallback([{}], 0);
          self.gridApi.showNoRowsOverlay();
        }
        if (body.fechaingresoInicio == '') {
          self.$snotify.error('El campo Fecha de Ingreso en requerido', {
            timeout: 3000,
          });
          event.successCallback([{}], 0);
          self.gridApi.showNoRowsOverlay();
        }
        if (body.fechaingresoFin == '') {
          self.$snotify.error('El campo Fecha de Ingreso en requerido', {
            timeout: 3000,
          });
          event.successCallback([{}], 0);
          self.gridApi.showNoRowsOverlay();
        }
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        self.pagina = Math.ceil(
          event.request.startRow / self.cant_regs_pag + 1
        );

        body.pagina = self.pagina;

        fetchReportesSerie(
          {
            ubicacion: body.ubicacion,
            fechaingresoInicio: body.fechaingresoInicio,
            fechaingresoFin: body.fechaingresoFin,
            rut: body.rut,
            requerimiento: body.requerimiento,
            TipoEquipo: body.TipoEquipo,
            rack: body.rack,
            Bloque: body.Bloque,
            pagina: body.pagina,
          },
          'reportesNoSerie/get_filtered_rs'
        )
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '1') {
              if (response.data.data.length === 0) {
                self.$snotify.error('Sin registros', { timeout: 3000 });
                event.successCallback([{}], 0);
                self.gridApi.showNoRowsOverlay();
              } else {
                event.successCallback(
                  response.data.data.LISTA,
                  Number(response.data.cant_regs_pag.TOTAL_REGISTROS)
                );
                self.gridApi.hideOverlay();
                self.autoSizeAll(true);
              }
            } else {
              event.successCallback([{}], 0);
              self.$snotify.error(response.data.MENSAJE_RESPUESTA, {
                timeout: 3000,
              });
            }
          })
          .catch((error: any) => {
            event.successCallback([{}], 0);
            self.$snotify.error('Sin Registros', {
              timeout: 3000,
            });
          })
          .finally(() => {
            self.gridApi.setDomLayout('autoHeight');
          });
      },
    };
    this.getEquipos();
  }
  async btn_exportar() {
    let body: any = this.filtros2body();
    (body.extension = 'csv'),
      this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchReportesSerie(
      {
        body: body,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        user_id: JSON.parse(localStorage.getItem('user')).id,
        tipo_alerta: 'CONECTA_REPORTES_NO_SERIE',
      },
      'reportesNoSerie/exportar'
    )
      .then((data: any) => {
        this.showReporteGenerado = true;
        this.loadingService.hideLoading('btn_exportar');
        this.texto_reporte = data.data.MENSAJE_RESPUESTA;
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }
  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }
  //Busca dentro del resultado de la grilla
  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }

  //evita el click derecho
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionConsultar];

  constructor() {
    super();
    actionsEvent.onVerDetalle(this.handleVerDetalleClick);
  }
  params: any = '';
  handleVerDetalleClick(params: ICellRendererParams) {
    this.params = params.data;

    this.mostrarModalVerDetalle = true;
  }
  handleCierreModalVerDetalle() {
    this.mostrarModalVerDetalle = false;
  }

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  filtros2body() {
    let body: any = {};
    body.ubicacion = this.formFields.ubicacion.value
      ? this.formFields.ubicacion.value
      : '';
    body.fechaingresoInicio = moment(
      String(this.formFields.fechaingresoInicio.value)
    ).format('YYYY/MM/DD HH:MM:SS')
      ? this.formFields.fechaingresoInicio.value
      : '';
    body.fechaingresoFin = moment(
      String(this.formFields.fechaingresoFin.value)
    ).format('YYYY/MM/DD HH:MM:SS')
      ? this.formFields.fechaingresoFin.value
      : '';
    body.rut = this.formFields.rut.value ? this.formFields.rut.value : '';
    body.requerimiento = this.formFields.requerimiento.value
      ? this.formFields.requerimiento.value
      : '';
    body.TipoEquipo = this.formFields.TipoEquipo.value
      ? this.formFields.TipoEquipo.value
      : '';
    body.rack = this.formFields.rack.value ? this.formFields.rack.value : '';
    body.Bloque = this.formFields.Bloque.value
      ? this.formFields.Bloque.value
      : '';

    return body;
  }

  filtroRequerimiento(loadWidget: boolean) {
    this.gridApi.setServerSideDatasource(this.serverSide);
  }
}
